module.exports = __webpack_public_path__ + "img/W_logopackhai.e1051293.png";